<template>
  <div class="content">
    <div v-if="isWatching" class="content__videos-wrapper">
      <div class="content__video">
        <CourseVideo
          :video="video"
          :isWatching="isWatching"
          :quizId="quizId"
          :hasPassedQuiz="isQuizFinished(quizStatus)"
          :nextVideo="nextVideo"
          :videoStatus="videoStatus"
          :courseId="courseId"
          @isLoadingVideo="setLoader"
          @toggleVideo="$emit('toggleVideo')"
          @toggleWatched="$emit('toggleWatched')"
        />
      </div>
    </div>
    <div v-if="isTakingQuiz" class="content__quiz">
      <MediaDelegate
        v-bind="{
          parentType: 'course',
          content: { id: quizId, type: 'quiz' },
          userCompletionStatus: quizStatus,
          contentTitle: levelTitle,
          nextMedia: nextVideo,
        }"
        @is-loading="setLoader"
      />
    </div>
    <div v-if="isTakingExercises" class="content__exercises">
      <MediaDelegate
        v-bind="{
          parentType: 'course',
          content: { type: 'exercise', media: exercises },
          hasAccess: isUser,
        }"
      />
    </div>
    <div v-if="isLoading" class="content__loader-wrapper">
      <ActionLoader loaderClass="content__loader" name="ball-clip-rotate" />
    </div>
  </div>
</template>

<script>
import ActionLoader from '@/components/shared/ActionLoader.vue'
import MediaDelegate from '@/components/media/MediaDelegate.vue'
import CONSTANTS from '@/constants'
import CourseVideo from './CourseVideo.vue'

export default {
  name: 'Content',
  components: {
    CourseVideo,
    MediaDelegate,
    ActionLoader,
  },
  props: {
    video: {
      type: Object,
      required: false,
    },
    nextVideo: {
      type: Object,
      required: false,
    },
    isWatching: {
      type: Boolean,
      required: true,
    },
    videoStatus: {
      type: String,
      required: true,
    },
    quizId: {
      type: String,
      required: false,
    },
    isTakingQuiz: {
      type: Boolean,
      required: true,
    },
    quizStatus: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    levelTitle: {
      type: String,
      required: true,
    },
    courseId: {
      type: String,
      required: true,
    },
    exercises: {
      type: Array,
      required: false,
    },
    isTakingExercises: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },
    isUser: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    setLoader(e) {
      this.$emit('isLoading', e)
    },
    isQuizFinished(status) {
      return CONSTANTS.CONTENT_USER_STATUS.FINISHED === status
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  &__loader-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0 50px 0;
  }
}
</style>
